<template>
  <div class="selection-list">
    <header>
      <h3>{{ title }}</h3>
      <button
        @click="newCustomer"
        v-if="showNewCustomer"
        class="white-pill-s add-btn"
      >
        <span></span>
        <span></span>
        <!--  <inline-svg class="add-btn" src="/images/add-btn.svg"></inline-svg> -->
      </button>
    </header>

    <div class="filter" v-if="addresses.length > 5">
      <input
        class="grey-field"
        type="text"
        name="filter"
        v-model="search"
        placeholder="Zoeken..."
      />
    </div>
    <div class="list">
      <ul class="">
        <li class="placeholder" v-if="filteredList.length < 1">
          <p class="placeholder">De lijst is nog leeg</p>
        </li>
        <li
          v-for="address in filteredList"
          :key="address.id"
          @click="$emit('setAddress', address)"
          :class="selectedCheck(address)"
        >
          <div v-show="type === 'deliver'">
            <p class="company">{{ address.company }}</p>
            <p class="name">{{ address.city }}</p>
            <p class="name">T.a.v. {{ address.name }}</p>
            <remove-button
              @remove="removeAddress(address.id)"
              v-if="address.id !== currentAddress.id"
            ></remove-button>
          </div>

          <div v-show="type === 'pickUp'">
            <p class="company">{{ address.company }}</p>
            <p class="street">
              {{ address.street }} {{ address.number }} {{ address.addition }}
            </p>
          </div>

          <div v-if="type === 'invoice'">
            <p class="company" v-if="address.customerNumber">
              {{ address.customerNumber }}
            </p>
            <p class="company">{{ address.company }}</p>
            <p class="company" v-if="showSearchName">
              {{ address.searchName }}
            </p>
            <p class="name">{{ address.city }}</p>

            <remove-button
              @remove="removeAddress(address.customerNumber)"
              v-if="address.newCustomer && !currentAddress.newCustomer"
            ></remove-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * Address selectionlist component
 *
 * Properties:
 * - type - deliver, pickUp, invoice
 * - currentAddress - selected address
 */
import RemoveButton from '@/components/ui/RemoveButton.vue'
import SortMixin from '@/mixins/SortMixin'
import AddNewCustomer from '@/dialogs/AddNewCustomer'
import { useAddressBookStore } from '@/stores/AddressBook.store'
import { useShopsStore } from '@/stores/Shops.store'
import { mapStores } from 'pinia'
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue'

export default {
  props: {
    currentAddress: Object,
    type: String,
    title: {
      type: String,
      default: 'Adreslijst'
    }
  },
  data() {
    return {
      search: ''
    }
  },
  mixins: [SortMixin],
  components: {
    RemoveButton
  },
  methods: {
    newCustomer() {
      this.$modal.show(
        AddNewCustomer,
        {
          callback: (address) => {
            this.$emit('setNewCustomer', address)
          }
        },
        { width: 445, height: 'auto' }
      )
    },
    removeAddress(id) {
      this.$modal.show(
        ConfirmationDialog,
        {
          text:
            'Weet u zeker dat u het adres definitief uit uw adresboek wil verwijderen?',
          buttons: [
            {
              title: 'Annuleren',
              class: 'pill-button secondary'
            },
            {
              title: 'Verwijderen',
              class: 'pill-button',
              handler: () => {
                if (this.type === 'deliver') {
                  this.addressBookStore.deleteDeliveryAddress(id)
                } else if (this.type === 'invoice') {
                  this.addressBookStore.deleteInvoiceAddress(id)
                }
              }
            }
          ]
        },
        {
          width: 400,
          height: 'auto'
        }
      )
    },
    selectedCheck(address) {
      if (this.type === 'invoice') {
        if (address.customerNumber === this.currentAddress.customerNumber) {
          return 'selected'
        } else {
          return ''
        }
      } else {
        if (address.id === this.currentAddress.id) {
          return 'selected'
        } else {
          return ''
        }
      }
    }
  },
  computed: {
    ...mapStores(useAddressBookStore, useShopsStore),
    custom() {
      return this.rootStore.theme.customFields
    },
    showSearchName() {
      return this.custom.addresses.showSearchName
    },
    shops() {
      return this.shopsStore.shopsList
    },
    invoiceAddressesList() {
      return this.addressBookStore.invoiceAddresses
    },
    deliveryAddressesList() {
      return this.addressBookStore.deliveryAddresses
    },
    addresses() {
      let list
      if (this.type === 'deliver') {
        list = this.deliveryAddressesList
      } else if (this.type === 'invoice') {
        list = this.invoiceAddressesList
      } else if (this.type === 'pickUp') {
        list = this.shops
      }

      return list
    },
    showNewCustomer() {
      if (this.type != 'invoice' || this.custom.addresses.newInvoice) {
        return false
      } else {
        return !this.invoiceAddressesList.some((addr) => {
          return addr.newCustomer
        })
      }
    },
    filteredList() {
      return this.addresses.filter((address) => {
        if (address.hide) return false
        const arr = Object.values(address)
        let show = false
        var el = arr.find((a) => {
          if (typeof a === 'string') {
            if (a.toLowerCase().includes(this.search.toLowerCase())) {
              show = true
            }
            return
          }
        })

        return show
      })
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  //margin: 25px 0 5px;
}

header {
  padding: 20px 0;
}

.list-header {
  display: flex;
  h3 {
    flex-grow: 1;
  }
  button {
    flex: 0 0 35px;
    :deep(circle) {
      fill: var(--main-color);
    }
  }

  .add-btn {
    margin-top: -5px;
  }
}

.selection-list {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  //overflow: hidden;

  h3 {
    padding-left: 5px;
  }
}

.list {
  //overflow-x: visible;
  //overflow-y: scroll;
  //margin: 0px -13px;
}

.filter {
  padding: 0 20px 10px;

  input[type='text'] {
    width: 100%;
  }
}

li {
  position: relative;
  white-space: nowrap;
  line-height: normal;
  //min-height: 57px;
  padding: 9px 14px;
  transition: 0.4s all;
  border-radius: 25px;
  margin-bottom: 8px;

  border: 1px solid var(--selected-color);

  .del-cross {
    display: none;
  }

  &.placeholder:hover {
    cursor: default;
    box-shadow: none;
  }

  &:hover {
    cursor: pointer;
    box-shadow: var(--default-shadow);
    //font-weight: 500;

    .del-cross {
      display: block;
      position: absolute;
      right: 6px;
      top: calc(50% - 10px);

      &.hide-city {
        top: 15px;
      }
    }
  }

  p {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.selected {
    background-color: var(--selected-color);
    box-shadow: var(--default-shadow);
    border: none;

    cursor: auto;
    font-weight: 500;
    padding: 11px 14px;
  }

  div {
    //display: table-cell;
    //height: 57px;
    //padding: 5px 2px 5px 0px;
    vertical-align: middle;
  }
}
</style>
